import React from 'react';
import Lottie from 'react-lottie';
import './Celebration_Lottie.css';
import * as animationData from './Celebration_Lottie.json';

function Celebration_Lottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='Celebration_Lottie_icon'>
                <Lottie className="me-auto"
                    options={defaultOptions}
                />
            </div>
        </section>
    );
}
export default Celebration_Lottie;